// src/pages/logout/Logout.js
import React from "react";
// import "./logout.css";

export default function Logout() {
  return (
    <div className="logout">
      <h1>Log Out Page</h1>
    </div>
  );
}
